<div class="position-relative">
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <div class="panel-title"> Add Alert Rule</div>
    <form [formGroup]="alertRuleForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="make-responsive">
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Alert Id</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="alertId" (selectionChange)="onSelectEvent($event)">
                        <mat-option *ngFor="let item of alertListForTenant" [value]="item['alertId']">{{item['alertId']}}</mat-option>
                      </mat-select>
                </mat-form-field>
            </div>
            <ng-container *ngIf="bindSelectedAlertRuleData">
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Alert Description</mat-label>
                    <input [readonly]="true" matInput formControlName="alertDesc">
                    <ng-container *ngIf="formSubmitted && formValues['alertDesc'].errors">
                        <mat-error *ngIf="formValues['alertDesc'].errors?.['required']">
                            <em class="fas fa-exclamation-circle mr-2"></em>Alert Description is required
                        </mat-error>
                    </ng-container>                
                </mat-form-field>
            </div>
            <div class="mt-top-2 field" >
                <mat-form-field class="field">
                    <mat-label>Alert Type</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="class" [disabled]="true">
                        <mat-option *ngFor="let item of classType" [value]="item" selected >
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="modal-form d-flex">
                <mat-form-field class="field">
                    <mat-label>Select Scope</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="type" [disabled]="true">
                        <mat-option *ngFor="let item of scope" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Select Severity</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="alertSeverity">
                        <mat-option *ngFor="let item of alertSeveritydd; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Select Action</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="action">
                        <mat-option *ngFor="let item of alertActionsdd; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Select Category</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="alertCategory">
                        <mat-option *ngFor="let item of alertCategorydd; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Select Category Nature</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="categoryNature">
                        <mat-option *ngFor="let item of alertCategoryNaturedd; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Excluded Zone Risk Type</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="excludedZoneRiskTypes">
                        <mat-option *ngFor="let item of zoneRiskTypeList; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>SMS</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="sms">
                        <mat-option *ngFor="let item of booleanArray; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Email</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="email">
                        <mat-option *ngFor="let item of booleanArray; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>C2D</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="c2d">
                        <mat-option *ngFor="let item of booleanArray; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Web Notification</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="webNotification">
                        <mat-option *ngFor="let item of booleanArray; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Push Notification</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="pushNotification">
                        <mat-option *ngFor="let item of booleanArray; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Auto Close</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="autoClose">
                        <mat-option *ngFor="let item of booleanArray; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>MType</mat-label>
                    <input matInput formControlName="mtype">
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Message</mat-label>
                    <input matInput formControlName="message">
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Trigger Delay</mat-label>
                    <input matInput formControlName="triggerDelay">
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Duplicate Duration</mat-label>
                    <input matInput formControlName="duplicateDuration">
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Delay Alert Duration</mat-label>
                    <input matInput formControlName="delayAlertDuration">
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>UOM</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="uom">
                        <mat-option *ngFor="let item of uom; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="mt-top-2 field">
                <mat-form-field class="field">
                    <mat-label>Active</mat-label>
                    <mat-select  [disableOptionCentering]="true" formControlName="active">
                        <mat-option *ngFor="let item of booleanArray; let i = index" [value]="item" selected>
                            {{item | titlecase}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>

            </ng-container>
        </div>
        <div class="btn-basket">
            <button mat-raised-button color="primary" data-dismiss="modal" type="button"
                (click)="closeModal()">Close</button>
            <button  mat-raised-button color="primary" type="submit">
                {{ alertRuleEdit ? 'Update' : 'Submit' }}
            </button>
        </div>
    </form>
    <label *ngIf="errorMessage">{{errorMessage}}</label>
    </div>